import { render } from "./OuterMetadataInput.vue?vue&type=template&id=32f61401&scoped=true&ts=true"
import script from "./OuterMetadataInput.vue?vue&type=script&lang=ts"
export * from "./OuterMetadataInput.vue?vue&type=script&lang=ts"

import "./OuterMetadataInput.vue?vue&type=style&index=0&id=32f61401&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f61401"]])

export default __exports__